export class DncData{
    DncId:number;
    DncGuid:any;
    OrgId:number;
    DealerId:number;
    FirstName: any;
    LastName: any;
    Vin:any;
    EmailAddress: any;
    Address1: any;
    Address2: any;
    City: any;
    State :any;
    ZipCode: any;
    PhoneNum: any;
    EmailDnc:boolean;
    MailDnc:boolean;
    PhoneDnc:boolean;
    IsDeleted:boolean;
    CreatedBy:any;
    CreatedDt:any;
    UpdatedBy:any;
    UpdatedDt:any;
    Message:any;
    DealerName:any;
}